import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@mode/capra';
import { PlanCardComponent } from '../plan-card/plan-card.component';

@Component({
  selector: 'mode-team-plan',
  standalone: true,
  imports: [CommonModule, IconComponent, PlanCardComponent],
  templateUrl: './team-plan.component.html',
  styleUrls: ['./team-plan.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamPlanComponent {
  public readonly planFeatures: readonly string[] = [
    'Up to 50 users',
    '500MB/query',
    '20GB monthly throughput',
    'Scheduled dashboards',
    'Email & slack sharing',
    'Standard support',
  ];
  @Input() isUpgradePlansFlow = false;
}
